import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
// ADD THIS IMPORT: Import HelmetProvider from react-helmet-async
import { HelmetProvider } from 'react-helmet-async';


const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    {/* WRAP your App component with HelmetProvider */}
    <HelmetProvider>
      <App />
    </HelmetProvider>
    {/* END HelmetProvider wrap */}
  </StrictMode>
);